<template>
  <div data-testid="shop-cart-header" class="flex w-full items-center justify-between">
    <div class="flex items-center gap-2">
      <MdiSvg :path="mdiCartOutline" :size="24" class="text-main" />
      <h2 class="text-headline-m text-main">{{ t('FestivalShop.cart.orderSummary', { count: itemCount }) }}</h2>
    </div>
    <button
      data-testid="shop-cart-close-btn"
      class="flex h-10 w-10 items-center justify-center rounded-sm bg-transparent transition-colors hover:bg-state-hover-neutral"
      type="button"
      :aria-label="t('FestivalShop.cart.closeCart')"
      @click="$emit('close')"
    >
      <MdiSvg :path="mdiClose" :size="24" class="text-main" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { mdiCartOutline, mdiClose } from '@mdi/js'
import { MdiSvg } from '@ramp106/omrjs-core-ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

export interface Props {
  itemCount?: number
}

withDefaults(defineProps<Props>(), {
  itemCount: 0,
})

defineEmits<{
  close: []
}>()
</script>
